<template>
  <div class="detail-container">
    <div class="status-container">
      <div>索赔单号：{{ claimantInfo.claimStatementId }}</div>
      <div class="status">状态：{{ claimantInfo.auditResultDisplay }}</div>
      <span
        v-if="pageIndex === 'detail'"
        class="btn"
        @click="handleViewRecord('record')"
        >查看记录</span
      >
    </div>
    <div v-if="pageIndex === 'detail'" class="form_info">
      <el-form
        :inline="true"
        :model="claimantInfo"
        :rules="fieldsData"
        ref="form"
        label-width="160px"
      >
        <!-- 索赔基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            索赔基本信息
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="索赔节点" prop="claimNode">
            <el-select
              v-model="claimantInfo.claimNode"
              :disabled="getDisabledField('claimNode')"
              filterable
              clearable
            >
              <el-option label="开箱" :value="'1'"> </el-option>
              <el-option label="制程" :value="'2'"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="索赔类型" prop="claimType">
            <el-select
              v-model="claimantInfo.claimType"
              filterable
              clearable
              :disabled="getDisabledField('claimType')"
            >
              <el-option
                v-for="(item, index) in splxList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开箱日期" prop="openBoxDate">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimantInfo.openBoxDate"
              placeholder="请选择"
              :disabled="getDisabledField('openBoxDate')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="销售订单号" prop="claimStatementNum">
            <el-input
              v-model="claimantInfo.claimStatementNum"
              placeholder="请输入"
              :disabled="getDisabledField('claimStatementNum  ')"
            ></el-input>
          </el-form-item>
          <!-- 零部件专业 -->
          <el-form-item label="零部件专业" prop="lbjzyList">
            <el-select
              multiple
              v-model="claimantInfo.lbjzyList"
              filterable
              clearable
              :disabled="getDisabledField('lbjzyList')"
            >
              <el-option
                v-for="(item, index) in partMajorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="VIN" prop="vin" v-if="claimantInfo.vin">
            <el-input
              v-model="claimantInfo.vin"
              placeholder="请输入"
              :disabled="getDisabledField('vin')"
            ></el-input>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item label="国家" prop="country">
            <el-select
              :disabled="getDisabledField('customerCountry')"
              filterable
              clearable
              v-model="claimantInfo.country"
              placeholder="请选择"
            >
              <el-option
                v-for="item in Object.values(getSession('nationList'))"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户账号" prop="customerAccountNum">
            <el-input
              v-model="claimantInfo.customerAccountNum"
              :disabled="getDisabledField('customerAccountNum')"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户索赔号" prop="customerClaimNumber">
            <el-input v-model="claimantInfo.customerClaimNumber" :disabled="getDisabledField('customerClaimNumber')"></el-input>
          </el-form-item>
        </div>
        <!-- 索赔基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            索赔基本信息
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item label="发生日期" prop="happenDate">
            <el-date-picker
              :disabled="getDisabledField('happenDate')"
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimantInfo.happenDate"
            ></el-date-picker>
          </el-form-item>
          <!-- 问题类别 -->
          <!--          <el-form-item label="问题类别" prop="questionType">-->
          <!--            <el-select-->
          <!--              v-model="claimantInfo.questionType"-->
          <!--              :disabled="getDisabledField('questionType')"-->
          <!--            >-->
          <!--              <el-option label="客户PDI" value="客户PDI"> </el-option>-->
          <!--              <el-option label="终端客户" value="终端客户"> </el-option>-->
          <!--              <el-option label="零部件质量" value="零部件质量"> </el-option>-->
          <!--              <el-option label="零部件差缺" value="零部件差缺"> </el-option>-->
          <!--              <el-option label="零部件运损" value="零部件运损"> </el-option>-->
          <!--              <el-option label="港口救援" value="港口救援"> </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!-- 维修方案 -->
          <!--          <el-form-item label="维修方案" prop="repairPlan">-->
          <!--            <el-select-->
          <!--              :disabled="getDisabledField('repairPlan')"-->
          <!--              v-model="claimantInfo.repairPlan"-->
          <!--              placeholder=""-->
          <!--              @change="changRepairPlan"-->
          <!--            >-->
          <!--              <el-option label="维修" :value="0"> </el-option>-->
          <!--              <el-option label="更换" :value="1"> </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!-- 故障现象 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障现象原文"
              prop="symptom"
            >
              <el-input
                :disabled="getDisabledField('symptom')"
                type="textarea"
                v-model="claimantInfo.symptom"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="claimantInfo.symptom"
                field="symptomCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item label="故障现象" prop="symptomCn">
              <el-input
                :disabled="getDisabledField('symptomCn')"
                type="textarea"
                v-model="claimantInfo.symptomCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 故障初步原因 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障初步原因原文"
              prop="preliminaryCauseOfFailure"
            >
              <el-input
                :disabled="getDisabledField('preliminaryCauseOfFailure')"
                type="textarea"
                v-model="claimantInfo.preliminaryCauseOfFailure"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="claimantInfo.preliminaryCauseOfFailure"
                field="preliminaryCauseOfFailureCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item
              label="故障初步原因"
              prop="preliminaryCauseOfFailureCn"
            >
              <el-input
                :disabled="getDisabledField('preliminaryCauseOfFailureCn')"
                type="textarea"
                v-model="claimantInfo.preliminaryCauseOfFailureCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障处理方案 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障处理方案原文"
              prop="processingScenarios"
            >
              <el-input
                :disabled="getDisabledField('processingScenarios')"
                type="textarea"
                v-model="claimantInfo.processingScenarios"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="claimantInfo.processingScenarios"
                field="processingScenariosCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item
              label="故障处理方案"
              prop="processingScenariosCn"
            >
              <el-input
                :disabled="getDisabledField('processingScenariosCn')"
                type="textarea"
                v-model="claimantInfo.processingScenariosCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <!-- 故障件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            故障件信息
          </div>
        </div>
        <div class="table-container" style="padding: 15px 18px 0 54px">
          <el-table :data="claimantInfo.faultPartsList" border stripe>
            <!-- 序号 -->
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            >
            </el-table-column>
            <!-- 外包装箱号 -->
            <el-table-column
              prop="boxNumber"
              label="外包装箱号"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input
                    disabled
                    v-model="scope.row.boxNumber"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              label="故障件件号"
              align="center"
              min-width="280px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('faultPartNumber')">
                  {{ scope.row.faultPartNumber }}
                </span>
                <el-autocomplete
                  v-else
                  :class="
                    scope.row.error
                      ? 'is-error table-auto-input'
                      : 'table-auto-input'
                  "
                  :ref="'autocomplete' + scope.$index"
                  v-model="scope.row.faultPartNumber"
                  placeholder="请输入"
                  :fetch-suggestions="getFaultList"
                  @select="handleSelect($event, scope.$index)"
                  @keyup.enter.native="
                    handleInput('autocomplete' + scope.$index)
                  "
                  @blur="onBlurFault(scope.$index)"
                  :disabled="getDisabledField('faultPartNumber')"
                ></el-autocomplete>
              </template>
            </el-table-column>
            <!-- 纸箱号 -->
            <el-table-column
              prop="cartonNumber"
              label="纸箱号"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input
                    disabled
                    v-model="scope.row.cartonNumber"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <!-- 更换数量 -->
            <el-table-column
              prop="changeQuantity"
              label="更换数量"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('changeQuantity')">
                  {{ scope.row.changeQuantity }}
                </span>
                <el-input-number
                  v-else
                  :disabled="claimantInfo.repairPlan == 0"
                  :controls="false"
                  :precision="0"
                  v-model="scope.row.changeQuantity"
                  placeholder="请输入"
                  @change="getTotalPrice('fault', scope.$index)"
                ></el-input-number>
              </template>
            </el-table-column>
            <!-- 维修方案 -->
            <el-table-column
              prop="repairPlan"
              label="维修方案"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-select
                    v-model="scope.row.repairPlan"
                    @change="changRepairPlan(scope, scope.$index)"
                    disabled
                    filterable
                    clearable
                  >
                    <el-option label="补发" :value="'2'"> </el-option>
                    <el-option label="更换" :value="'1'"> </el-option>
                    <el-option label="维修" :value="'0'"> </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <!-- 零部件来源 -->
            <el-table-column
              prop="sourceOfComponents"
              label="零部件来源"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-select
                    v-model="scope.row.sourceOfComponents"
                    @change="getTotalPrice('fault', scope.$index)"
                    placeholder=""
                    disabled
                    filterable
                    clearable
                  >
                    <el-option label="收费件" :value="1"> </el-option>
                    <el-option label="海外免费件" :value="2"> </el-option>
                    <el-option label="工厂免费件" :value="3"> </el-option>
                    <el-option label="供应商免费件" :value="4"> </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="workingHours"
              label="单件工时"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  style="
                    position: relative;
                    width: fit-content;
                  "
                >
                  <!--                  <el-button size="mini" @click="scope.row.workingHours++"   @mouseup.native="getTotalPrice('fault', scope.$index)" :disabled="$route.query.operate == '查看详情'">+</el-button>-->
                  <span style="margin: 0 10px">{{
                    scope.row.workingHours
                      ? scope.row.workingHours
                      : (scope.row.workingHours = 0)
                  }}</span>
                  <!--                  <el-button size="mini" @click="scope.row.workingHours&#45;&#45;" @mouseup.native="getTotalPrice('fault', scope.$index)" :disabled="$route.query.operate == '查看详情'||scope.row.workingHours==0">-</el-button>-->
                </div>
              </template>
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="shippingFee"
              label="运费"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  style="position: relative; width: fit-content;"
                >
                  <el-input
                    disabled
                    v-model="scope.row.shippingFee"
                    class="prepend-padding"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input>
                  <div class="number-input-prepend">
                    {{ claimantInfo.currency == 0 ? "￥" : "" }}
                    {{ claimantInfo.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="tariff"
              label="关税"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  style="position: relative; width: fit-content;"
                >
                  <el-input
                    disabled
                    v-model="scope.row.tariff"
                    class="prepend-padding"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input>
                  <div class="number-input-prepend">
                    {{ claimantInfo.currency == 0 ? "￥" : "" }}
                    {{ claimantInfo.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="otherExpenses"
              label="其他费用"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  style="position: relative; width: fit-content;"
                >
                  <el-input
                    disabled
                    v-model="scope.row.otherExpenses"
                    class="prepend-padding"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input>
                  <div class="number-input-prepend">
                    {{ claimantInfo.currency == 0 ? "￥" : "" }}
                    {{ claimantInfo.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 故障件名称 -->
            <el-table-column
              prop="faultPartNameZh"
              label="故障件名称"
              align="center"
              min-width="250px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input
                    disabled
                    v-model="scope.row.faultPartNameZh"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="faultPartUnitPrice"
              label="故障件单价"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  style="position: relative; width: fit-content;"
                >
                  <el-input
                    disabled
                    v-model="scope.row.faultPartUnitPrice"
                    class="prepend-padding"
                  ></el-input>
                  <div class="number-input-prepend">
                    {{ claimantInfo.currency == 0 ? "￥" : "" }}
                    {{ claimantInfo.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 管理费费率 v-if="claimantInfo.managementFeeRate !== 0"-->
            <el-table-column
              prop="managementFeeRate"
              label="管理费费率"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('managementFeeRate')">
                  {{ scope.row.managementFeeRate }}
                </span>
                <el-input-number
                  class="number-input"
                  :controls="false"
                  :precision="3"
                  v-else
                  @change="getTotalPrice('fault', scope.$index)"
                  v-model="scope.row.managementFeeRate"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="laborCost"
              label="工时费用"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.laborCost }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="materialCost"
              label="材料费用"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.materialCost }}
                </div>
              </template>
            </el-table-column>
            <!-- 故障件总金额 -->
            <el-table-column
              prop="faultPartTotalPrice"
              label="总金额"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.faultPartTotalPrice }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="travelPrice"
              label="差旅费"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.travelPrice }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            费用信息
          </div>
        </div>
        <div class="form-container">
          <!-- 工时 -->
          <el-form-item label="工时总量(h)" prop="manHour">
            <el-input-number
              :disabled="getDisabledField('manHour')"
              v-model="claimantInfo.manHour"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              class="number-input"
              :placeholder="getDisabledField('manHour') ? '' : '请输入'"
              @change="getTotalPrice('fault', scope.$index)"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item label="工时单价" prop="hourlyRate">
            <el-input-number
              :disabled="getDisabledField('hourlyRate')"
              v-model="claimantInfo.hourlyRate"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              @change="getTotalPrice('fault', scope.$index)"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item label="工时总费用" prop="totalCostOfWork">
            <el-input-number
              :disabled="getDisabledField('totalCostOfWork')"
              v-model="claimantInfo.totalCostOfWork"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item label="材料总费用" prop="materialTotalCost">
            <el-input-number
              :disabled="getDisabledField('materialTotalCost')"
              v-model="claimantInfo.materialTotalCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 运费 -->
          <el-form-item label="运费总费用" prop="freight">
            <el-input-number
              :disabled="getDisabledField('freight')"
              v-model="claimantInfo.freight"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              :placeholder="getDisabledField('freight') ? '' : '请输入'"
              @change="getTotalPrice('fault', scope.$index)"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 关税 -->
          <el-form-item label="关税总费用" prop="tariff">
            <el-input-number
              :disabled="getDisabledField('tariff')"
              v-model="claimantInfo.tariff"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              :placeholder="getDisabledField('tariff') ? '' : '请输入'"
              @change="getTotalPrice('fault', scope.$index)"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他费用 -->
          <el-form-item label="其他总费用" prop="otherTotalCost">
            <el-input-number
              :disabled="getDisabledField('otherTotalCost')"
              v-model="claimantInfo.otherTotalCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              :placeholder="getDisabledField('otherTotalCost') ? '' : '请输入'"
              @change="getTotalPrice('fault', scope.$index)"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 差旅费 -->
          <el-form-item label="差旅费" prop="travelPrice">
            <el-input-number
              :disabled="getDisabledField('travelPrice')"
              v-model="claimantInfo.travelPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              placeholder="请输入"
              @change="getTotalPrice('fault', scope.$index)"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <br />
          <!-- 其他费用说明 -->
          <el-form-item label="其他费用说明原文" prop="otherExpenses">
            <el-input
              :disabled="getDisabledField('otherExpenses')"
              v-model="claimantInfo.otherExpenses"
            ></el-input>
          </el-form-item>
          <el-form-item label=" " label-width="60px">
            <translate
              :content="claimantInfo.otherExpenses"
              field="otherInstructionZh"
              @getTranslateVal="getTranslateVal"
            />
          </el-form-item>
          <br />
          <el-form-item label="其他费用说明" prop="otherInstructionZh">
            <el-input
              :disabled="getDisabledField('otherInstructionZh')"
              v-model="claimantInfo.otherInstructionZh"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=" "
            v-show="claimantInfo.auditResultDisplay == '待正审'"
            label-width="60px"
          >
            <translate
              :content="claimantInfo.otherInstructionZh"
              field="otherInstruction"
              from="zh-CHS"
              to="en"
              @getTranslateVal="getTranslateVal"
            />
          </el-form-item>
          <br />
          <!-- 索赔总费用 -->
          <el-form-item label="索赔总费用" prop="claimTotalCost">
            <el-input-number
              :disabled="getDisabledField('claimTotalCost')"
              v-model="claimantInfo.claimTotalCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item label="结算币种" prop="currency">
            <el-select
              :disabled="getDisabledField('currency')"
              v-model="claimantInfo.currency"
              placeholder=""
              filterable
              clearable
            >
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 责任判定 -->
        <div
          v-if="
            !(
              $route.query.operate == '查看详情' &&
              claimantInfo.auditResultDisplay == '待正审'
            )
          "
          class="hearder-title"
        >
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            责任判定
            <span
              @click="handleHistoryResponsibility()"
              style="
                text-decoration: underline;
                cursor: pointer;
                margin-left: 10px;
                padding: 0px;
                color: var(--theme-color);"
              >历史判定</span>
            <!-- <el-button
              type="text"
              @click="handleHistoryResponsibility()"
              style="margin-left: 10px; padding: 0;color:var(--theme-color)"
            >
              历史判定
            </el-button> -->
            <history-responsibility-dialog
              ref="historyResponsibilityDialog"
              :responsibilityTypeList="responsibilityTypeList"
            />
          </div>
        </div>
        <div class="table-container" style="padding: 15px 18px 0 54px">
          <div class="zeren-list" v-for="(m, i) in zerenList" :key="i">
            <div class="flex_center" style="margin: 10px 0;">
              <span style="color: #333;font-size:14px;margin-right:10px;"
                >故障件选择</span
              >
              <el-select
                :disabled="
                  !(
                    claimantInfo.auditResultDisplay == '待正审' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)' ||
                        claimantInfo.auditResultDisplay ==
                          '待确认(责任主体)')) ||
                    ($route.query.operate == '责任确定' &&
                      claimantInfo.auditResultDisplay == '待确认(责任主体)')
                  )
                "
                filterable
                clearable
                v-model="m.faultPartId"
                placeholder="请选择"
              >
                <!-- @change="changefaultPartsData(i)" -->
                <el-option
                  v-for="item in claimantInfo.faultPartsList"
                  :key="item.faultPartId"
                  :label="item.faultPartNumber"
                  :value="item.faultPartId"
                  :disabled="
                    zerenList.some(
                      item2 => item2.faultPartId === item.faultPartId
                    )
                  "
                >
                </el-option>
              </el-select>
              <div
                v-if="
                  claimantInfo.auditResultDisplay == '待正审' ||
                    $route.query.operate == '责任确定' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)'))
                "
              >
                <i
                  class="el-icon-plus"
                  @click="handleAddFaultZeren"
                  style="cursor: pointer;color: #333;margin-left:10px;font-weight: bold;"
                ></i>
                <i
                  class="el-icon-delete"
                  @click="handleDeleteFaultZeren(i)"
                  style="cursor: pointer;color: #333;margin-left:10px;font-weight: bold;"
                ></i>
              </div>
            </div>
            <el-table :data="m.responsibilityPartList" border stripe>
              <!-- 序号 -->
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              >
              </el-table-column>
              <!-- 责任类型 -->
              <el-table-column
                prop="responsibilityType"
                label="责任类型"
                align="center"
                min-width="160px"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      claimantInfo.auditResultDisplay == '待正审' ||
                        $route.query.operate == '责任确定' ||
                        ($route.query.operate == '审核' &&
                          (claimantInfo.auditResultDisplay ==
                            '驳回(责任确定)' ||
                            claimantInfo.auditResultDisplay ==
                              '驳回(部长加签审批)'))
                    "
                  >
                    <el-select
                      v-model="scope.row.responsibilityType"
                      @change="
                        responsibilityTypeChange(scope.row, scope.$index, i)
                      "
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in responsibilityTypeList"
                        :key="index"
                        :label="item.value"
                        :value="Number(item.codeText)"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <span v-else>{{
                    getDictValueByCodeText(
                      responsibilityTypeList,
                      scope.row.responsibilityType
                    )
                  }}</span>
                </template>
              </el-table-column>
              <!-- 责任部门 -->
              <el-table-column
                prop="responsibilityDepartment"
                label="责任部门"
                align="center"
                min-width="160px"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      claimantInfo.auditResultDisplay == '待正审' ||
                        $route.query.operate == '责任确定' ||
                        ($route.query.operate == '审核' &&
                          (claimantInfo.auditResultDisplay ==
                            '驳回(责任确定)' ||
                            claimantInfo.auditResultDisplay ==
                              '驳回(部长加签审批)'))
                    "
                  >
                    <el-select
                      v-model="scope.row.responsibilityDepartment"
                      @change="
                        responsibilityDepartmentChange(scope.row, scope.$index, i)
                      "
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in responsibilityDepartmentListObj[
                          `responsibilityPart${scope.row.responsibilityType}`
                        ]"
                        :key="index"
                        :label="item.value"
                        :value="item.codeText"
                      >
                      </el-option>
                    </el-select>
                  </div>
                
                  <span v-else>{{ scope.row.responsibilityDepartment }}</span>
                </template>
              </el-table-column>
              <!-- 故障件件号 -->
              <el-table-column
                prop="faultPartNumber"
                label="故障件件号"
                align="center"
                min-width="220px"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      (claimantInfo.auditResultDisplay == '待正审' ||
                        $route.query.operate == '责任确定' ||
                        ($route.query.operate == '审核' &&
                          (claimantInfo.auditResultDisplay ==
                            '驳回(责任确定)' ||
                            claimantInfo.auditResultDisplay ==
                              '驳回(部长加签审批)'))) &&
                        scope.row.responsibilityDepartment === '供应商'
                    "
                  >
                    <el-select
                      size="mini"
                      v-model="scope.row.faultPartNumber"
                      placeholder="请选择"
                      @change="
                        responsibilityPartNumberChange(scope.row, scope.$index, i)
                      "
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="(item,
                        index) in claimantInfo.faultPartsList.filter(
                          item => item.faultPartId === m.faultPartId
                        )"
                        :key="index"
                        :label="item.faultPartNumber"
                        :value="item.faultPartNumber"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <span v-else>
                    {{
                      scope.row.responsibilityDepartment === "供应商"
                        ? scope.row.faultPartNumber
                        : "--"
                    }}
                  </span>
                </template>
              </el-table-column>
              <!-- 供应商代码 -->
              <el-table-column
                prop="responsibilitySupplierCode"
                label="供应商代码"
                align="center"
                min-width="220px"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      (claimantInfo.auditResultDisplay == '待正审' ||
                        $route.query.operate == '责任确定' ||
                        ($route.query.operate == '审核' &&
                          (claimantInfo.auditResultDisplay ==
                            '驳回(责任确定)' ||
                            claimantInfo.auditResultDisplay ==
                              '驳回(部长加签审批)'))) &&
                        scope.row.responsibilityDepartment === '供应商'
                    " 
                  >
                    <el-select
                      v-model="scope.row.responsibilitySupplierCode"
                      placeholder="请选择或输入"
                      filterable
                      clearable
                      allow-create
                      default-first-option
                      @change="
                        responsibilitySupplierCodeChange(
                          scope.row,
                          scope.$index,
                          i
                        )
                      "
                      @blur="handleSupplierCodeBlur(scope.row, scope.$index)"
                    >
                      <el-option
                        v-for="(item, index) in supplierList[scope.$index]"
                        :key="index"
                        :label="item.lifnr"
                        :value="item.lifnr"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <span v-else>
                    {{
                      scope.row.responsibilityDepartment === "供应商"
                        ? scope.row.responsibilitySupplierCode
                        : "--"
                    }}
                  </span>
                </template>
              </el-table-column>
              <!-- 供应商名称 -->
              <el-table-column
                prop="responsibilitySupplier"
                label="供应商名称"
                align="center"
                min-width="220px"
              >
                <template slot-scope="scope">
                  <!-- 如果当前供应商代码是手动输入的（即不在下拉列表中），则显示输入框 -->
                  <div
                    v-if="isManualSupplierCode(scope.row.responsibilitySupplierCode, scope.$index)"
                  >
                    <el-input
                      v-model="scope.row.responsibilitySupplier"
                      placeholder="请手动输入供应商名称"
                    ></el-input>
                  </div>
                  <!-- 否则，显示自动填充或已存在的名称 -->
                  <span v-else>
                    {{ scope.row.responsibilitySupplier || '--' }}
                  </span>
                </template>
              </el-table-column>
              <!-- 故障件采购价 -->
              <el-table-column
                prop="responsibilityPurchasePrice"
                label="故障件采购价"
                align="center"
                min-width="220px"
              >
                <template slot-scope="scope">
                  <!-- 如果当前供应商代码是手动输入的（即不在下拉列表中），则显示输入框 -->
                  <div
                    v-if="isManualSupplierCode(scope.row.responsibilitySupplierCode, scope.$index)"
                  >
                    <el-input
                      v-model="scope.row.sapPrice"
                      type="number"
                      placeholder="请手动输入故障件采购价"
                    ></el-input>
                  </div>
                  <!-- 否则，显示自动填充或已存在的名称 -->
                  <span v-else>
                    {{ scope.row.sapPrice || '--' }}
                  </span>
                </template>
              </el-table-column>
              <!-- 责任占比 -->
              <el-table-column
                prop="responsibilityRatio"
                label="责任占比"
                align="center"
                min-width="160px"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      claimantInfo.auditResultDisplay == '待正审' ||
                        $route.query.operate == '责任确定' ||
                        ($route.query.operate == '审核' &&
                          (claimantInfo.auditResultDisplay ==
                            '驳回(责任确定)' ||
                            claimantInfo.auditResultDisplay ==
                              '驳回(部长加签审批)'))
                    "
                    style="
                      position: relative;
                      width: fit-content;
                    "
                  >
                    <el-input-number
                      class="number-input"
                      v-model="scope.row.responsibilityRatio"
                      :controls="false"
                      :precision="2"
                      placeholder="请输入"
                    ></el-input-number>
                    <div class="number-input-append">
                    %
                  </div>
                  </div>
                  <span v-else>{{ scope.row.responsibilityRatio }}%</span>
                </template>
              </el-table-column>
              <!-- 货币单位 -->
              <el-table-column
                prop="currency"
                label="货币单位"
                align="center"
                min-width="160px"
              >
                <template slot-scope="scope">
                  {{ scope.row.currency === 0 ? "CNY" : "USD" }}
                </template>
              </el-table-column>
              <!-- 二赔金额 -->
              <el-table-column
                prop="secondDamages"
                label="二赔金额"
                align="center"
                min-width="160px"
                v-if="
                  claimantInfo.auditResultDisplay == '待结算' ||
                    claimantInfo.auditResultDisplay == '已结算'
                "
              >
                <template slot-scope="scope">
                  <el-input-number
                    v-if="
                      $route.query.operate === '确认金额' &&
                        scope.row.responsibilityDepartment === '供应商'
                    "
                    v-model="scope.row.secondDamages"
                    :controls="false"
                    :precision="2"
                    placeholder="请输入"
                  ></el-input-number>
                  <span v-else>
                    {{
                      scope.row.secondDamages || scope.row.secondDamages === 0
                        ? "¥"
                        : ""
                    }}{{ scope.row.secondDamages }}
                  </span>
                </template>
              </el-table-column>
              <!-- 责任说明 -->
              <el-table-column
                prop="responsibilityRemark"
                label="责任说明"
                align="center"
                min-width="160px"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      claimantInfo.auditResultDisplay == '待正审' ||
                        $route.query.operate == '责任确定' ||
                        ($route.query.operate == '审核' &&
                          (claimantInfo.auditResultDisplay ==
                            '驳回(责任确定)' ||
                            claimantInfo.auditResultDisplay ==
                              '驳回(部长加签审批)'))
                    "
                  >
                    <el-input
                      v-model="scope.row.responsibilityRemark"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                  <span v-else>{{ scope.row.responsibilityRemark }}</span>
                </template>
              </el-table-column>
              <!-- 操作 -->
              <el-table-column
                prop="id"
                label="操作"
                align="center"
                min-width="160px"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      claimantInfo.auditResultDisplay == '待正审' ||
                        $route.query.operate == '责任确定' ||
                        ($route.query.operate == '审核' &&
                          (claimantInfo.auditResultDisplay ==
                            '驳回(责任确定)' ||
                            claimantInfo.auditResultDisplay ==
                              '驳回(部长加签审批)'))
                    "
                    type="text"
                    @click="handleDeleteResponsibility(scope.$index, i)"
                  >
                    删除</el-button
                  >
                  <el-button
                    type="text"
                    @click="handleEditData('供应商二赔金额填写', scope.row)"
                    v-if="
                      $route.query.operate === '确认金额' &&
                        scope.row.responsibilityType == 2
                    "
                  >
                    编辑</el-button
                  >
                  <el-button
                    type="text"
                    @click="handleEditData('供应商二赔金额填写记录', scope.row)"
                    v-if="
                      (claimantInfo.auditResultDisplay == '待结算' ||
                        claimantInfo.auditResultDisplay == '已结算') &&
                        scope.row.responsibilityType == 2
                    "
                  >
                    历史记录</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div
              class="flex_default_center"
              v-show="
                claimantInfo.auditResultDisplay == '待正审' ||
                  $route.query.operate == '责任确定' ||
                  ($route.query.operate == '审核' &&
                    (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                      claimantInfo.auditResultDisplay == '驳回(部长加签审批)'))
              "
              style="width: 100%;height:40px;border:1px solid #EBEEF5; margin-top: 8px;"
            >
              <el-button
                plain
                class="primary-btn"
                icon="el-icon-plus"
                @click="handleAddResponsibility(i)"
                >添加责任主主体</el-button
              >
            </div>
          </div>
        </div>
        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            附件信息
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="附件信息">
            <div
              class="flex"
              v-for="(item, i) in claimantInfo.faultPartsList"
              :key="i"
            >
              <span style="font-weight: bold">附件{{ i + 1 }}:</span>
              <div class="file">
                <div
                  class="file-list"
                  style="cursor: pointer"
                  v-for="(data, idx) in item.fileList"
                  :key="idx"
                >
                  <div class="left">
                    <i class="el-icon-document"></i
                    ><span>{{ data.fileName }}</span>
                  </div>
                  <div class="down-icon" v-if="data.downStatus">已下载</div>
                  <div class="right" @click="downLoad(data.filePath, idx, i)">
                    下载
                  </div>
                  <div
                    class="right"
                    style="margin-left: 10px"
                    v-if="showViewBtn(data.fileType)"
                    @click="viewFile(data)"
                  >
                    预览
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <!-- 审核信息 -->
        <last-audit
          v-if="
            claimantInfo.claimStatementAudit &&
              (claimantInfo.claimStatementAudit.auditType ||
                claimantInfo.claimStatementAudit.auditType === 0) &&
              $route.query.operate == '查看详情'
          "
          :claimant="claimantInfo"
        />
      </el-form>
    </div>
    <div v-else class="record_info">
      <!-- 历史记录 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img
            class="title-icon"
            src="@/assets/img/title-icon.svg"
            alt="dark"
          />
          历史记录
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="handleViewRecord('detail')"
            >返回</el-button
          >
        </div>
      </div>
      <div class="form-container">
        <audit-record :recordList="recordList" />
      </div>
    </div>
    <view-img-video ref="viewRef" :list="previewFile" />
    <!-- 供应商二赔金额填写 -->
    <second-compensation-dialog
      ref="secondCompensationDialogRef"
      @success="getResponsibilityList"
    />
  </div>
</template>

<script>
import Translate from "@/components/translate";
import { getDictItem, getDictValueByCodeText, getDictValue } from "@/util/dict";
import AuditRecord from "./auditRecord.vue";
import {
  kdAuditHistoryList,
  gysPriceFillOutdataList,
  getECPDataByVIN,
  getPreset,
  getECPData,
  kdgetResponsibilityListApi
} from "@/api/seek";
import LastAudit from "./lastAudit.vue";
import ViewImgVideo from "@/components/viewImgVideo.vue";
import { getSession } from "@/util/localStor";
import CryptoJS from "crypto-js";
import HistoryResponsibilityDialog from "./historyResponsibilityDialog.vue";
import SecondCompensationDialog from "./secondCompensationDialog.vue";
import number from "@/components/number.vue";
import { getCurrentRoles, hasAnyRole } from "@/utils/role";

export default {
  components: {
    Translate,
    AuditRecord,
    LastAudit,
    ViewImgVideo,
    HistoryResponsibilityDialog,
    SecondCompensationDialog
  },
  props: {
    claimantInfo: {
      type: Object,
      default: () => {}
    },
    showExamineBtn: {
      type: Boolean,
      default: true
    },
    fieldsData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    previewFile: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      splxList: [
        {
          name: "运输损坏",
          id: "1"
        },
        {
          name: "货差",
          id: "2"
        },
        {
          name: "质量问题",
          id: "3"
        },
        {
          name: "状态不符",
          id: "4"
        },
        {
          name: "其他",
          id: "5"
        }
      ], //索赔类型
      responsibilityDepartmentListObj: {
        responsibilityPart1: [],
        responsibilityPart2: [],
        responsibilityPart3: []
      }, // 责任部门列表对象
      vinOptions: [], // vin列表
      showfaultListError: false, // 其他故障件错误
      faultList: [], // EPC系统故障件数据,
      faultPartsListSel: [],
      partMajorList: [
        {
          name: "车身",
          id: "1"
        },
        {
          name: "底盘",
          id: "2"
        },
        {
          name: "电器",
          id: "3"
        },
        {
          name: "内外饰",
          id: "4"
        },
        {
          name: "新能源",
          id: "5"
        },
        {
          name: "动力",
          id: "6"
        }
      ], //零部件专业
      pageIndex: "detail", // 详情 | 记录
      responsibilityTypeList: [],
      recordList: [],
      dialogVisible: false,
      supplierList: {},
      loading: false,
      exchangeRate: 1, // 汇率
      zerenList: []
    };
  },
  computed: {
    rules() {
      return this.fieldsData;
    }
  },
  async created() {
    this.responsibilityTypeList = await getDictItem("responsibilityType");
    this.faultPartsListSel = JSON.parse(
      JSON.stringify(this.claimantInfo.faultPartsList)
    );
    // 获取内部责任部门列表
    this.getResponsibilityDepartmentList("responsibilityPart1");
    // 获取外部责任部门列表
    this.getResponsibilityDepartmentList("responsibilityPart2");
    // 获取海外事业部责任部门列表
    this.getResponsibilityDepartmentList("responsibilityPart3");
    const res = await kdAuditHistoryList({
      data: { claimStatementId: this.claimantInfo.claimStatementId }
    });
    this.recordList = res.data;
    if (
      this.claimantInfo.responsibilityPartList &&
      this.claimantInfo.responsibilityPartList.length > 0
    ) {
      this.claimantInfo.responsibilityPartList.map((item, index) => {
        this.getSupplierList(item, index);
      });
    }
    this.getResponsibilityData();
    // if (this.claimantInfo.faultPartsList){

    //   this.claimantInfo.faultPartsList = this.claimantInfo.faultPartsList.filter(item => {
    //     return item.responsibilityPartList && item.responsibilityPartList.length > 0;
    //   }).map(item => {
    //     item.responsibilityPartList.forEach(item1 => {
    //       this.getSupplierList(item1);
    //     });
    //     return item;
    //   });
    // }
  },
  async mounted() {
    await this.getExchangeRate();
  },
  methods: {
    getSession,
    getDictValueByCodeText,
    // 获取当前责任方数据
    getZerenList() {
      return this.zerenList;
    },
    // 获取带责任方
    getResponsibilityData() {
      let arr = [];
      if (
        this.claimantInfo.faultPartsList &&
        this.claimantInfo.faultPartsList.length > 0
      ) {
        this.claimantInfo.faultPartsList.map(item => {
          if (
            item.responsibilityPartList &&
            item.responsibilityPartList.length > 0
          ) {
            arr.push(item);
          }
        });
      }
      this.$nextTick(() => {
        this.zerenList = [...arr];
      });
    },
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 判断字段是否禁用
    getDisabledField(value) {
      if (
        this.$route.query.operate === "查看详情" ||
        hasAnyRole(["章总", "OTS部部长"])
      ) {
        return true;
      }
      for (const key in this.fieldsData) {
        if (key == value) {
          return false;
        }
      }
      return true;
    },
    // 获取责任部门列表
    async getResponsibilityDepartmentList(field) {
      const responsibilityDepartmentList = await getDictItem(field);
      this.responsibilityDepartmentListObj[
        field
      ] = responsibilityDepartmentList;
    },
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const seconds = now
        .getSeconds()
        .toString()
        .padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      // 拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat)
        .toString()
        .toUpperCase();
      return { appId, timestamp, sign };
    },
    // 获取vin信息
    async vinRemoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const { appId, timestamp, sign } = this.getECPParams();
        const params = {
          appId,
          timestamp,
          sign,
          vin: query,
          account: this.claimantInfo.customerAccountNum
        };
        const res = await getECPDataByVIN(params);
        if (res.data) {
          this.loading = false;
          this.vinOptions = res.data;
          this.vinOptions?.map((item, i) => {
            if (item.vin == query) {
              this.$set(this.claimantInfo, "carBrand", item.brand);
              this.$set(this.claimantInfo, "carModel", item.model);
              this.$set(this.claimantInfo, "engineModel", item.engineModel);
              this.$set(this.claimantInfo, "productionDate", item.vinCreated);
            }
          });
        } else {
          this.loading = false;
          this.vinOptions = [];
          this.claimantInfo.vin = query;
          this.$set(this.claimantInfo, "carBrand", "");
          this.$set(this.claimantInfo, "carModel", "");
          this.$set(this.claimantInfo, "engineModel", "");
          this.$set(this.claimantInfo, "productionDate", "");
        }
      } else {
        this.vinOptions = [];
        this.$set(this.claimantInfo, "carBrand", "");
        this.$set(this.claimantInfo, "carModel", "");
        this.$set(this.claimantInfo, "engineModel", "");
        this.$set(this.claimantInfo, "productionDate", "");
      }
    },
    // vin 改变时获取车辆信息
    changeVin(val) {
      this.vinOptions?.map((item, i) => {
        if (item.vin == val) {
          this.$set(this.claimantInfo, "carBrand", item.brand);
          this.$set(this.claimantInfo, "carModel", item.model);
          this.$set(this.claimantInfo, "engineModel", item.engineModel);
          this.$set(this.claimantInfo, "productionDate", item.vinCreated);
        }
      });
    },
    // 修改维修方案
    changRepairPlan(val, index) {
      if (val == 0) {
        this.claimantInfo.sourceOfComponents = 0;
        this.claimantInfo.changeQuantity = 0;
        this.claimantInfo.faultPartsList?.map((item, index1) => {
          item.sourceOfComponents = 0;
          item.changeQuantity = 0;
          this.getTotalPrice("fault", index1);
        });
      }
      this.getTotalPrice("fault", index);
    },
    // 判断ECP数据中是否存在该故障件
    async findFault() {
      const faultIndex = this.faultList.findIndex(item => {
        return item.code === this.claimantInfo.faultPartNumber;
      });
      if (faultIndex === -1) {
        this.$set(this.claimantInfo, "faultPartNameZh", "");
        this.$set(this.claimantInfo, "faultPartName", "");
        this.$set(this.claimantInfo, "faultPartUnitPrice", "");
        this.getTotalPrice("fault");
        this.$emit("update:faultError", true);
      } else {
        this.$set(
          this.claimantInfo,
          "faultPartNameZh",
          this.faultList[faultIndex].name
        );
        this.$set(
          this.claimantInfo,
          "faultPartName",
          this.faultList[faultIndex][this.claimantInfo.languageType] ||
            this.faultList[faultIndex].en ||
            this.faultList[faultIndex].zh
        );
        this.$set(
          this.claimantInfo,
          "faultPartUnitPrice",
          this.claimantInfo.currency === 0
            ? (this.faultList[faultIndex].price * this.exchangeRate).toFixed(2)
            : this.faultList[faultIndex].price
        );
        this.getTotalPrice("fault");
        this.$emit("update:faultError", false);
      }
    },
    // 根据故障件件号，EPC系统获取故障件
    async getFault(queryString) {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        codeList: [queryString],
        account: this.claimantInfo.customerAccountNum
      };
      const res = await getECPData(params);
      const faultList = res.data;
      return faultList;
    },
    // 获取故障件列表
    async getFaultList(queryString, cb) {
      if (queryString && queryString.length >= 7) {
        const faultList = await this.getFault(queryString);
        this.faultList = [];
        faultList?.map(item => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      } else {
        this.faultList = [];
      }
      cb(this.faultList);
    },
    // 输入故障件
    handleInput(ref) {
      this.$refs[ref].$refs.input.blur(); // 取消焦点
      this.$refs[ref].activated = false; // 关闭下拉框
    },
    // 表格输入故障件获取数据
    async onBlurFault(index) {
      if (this.faultList.length === 0) {
        const faultList = await this.getFault(
          index === 0 || index
            ? this.claimantInfo.faultPartsList[index].faultPartNumber
            : this.claimantInfo.faultPartNumber
        );
        this.faultList = [];
        faultList?.map(item => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      }
      if (index === 0 || index) {
        if (!this.claimantInfo.faultPartsList[index].faultPartNumber) {
          this.claimantInfo.faultPartsList[index].error = undefined;
        } else {
          const faultIndex = this.faultList.findIndex(item => {
            return (
              item.code ===
              this.claimantInfo.faultPartsList[index].faultPartNumber
            );
          });
          if (faultIndex === -1) {
            this.claimantInfo.faultPartsList[index].faultPartNameZh = "";
            this.claimantInfo.faultPartsList[index].faultPartName = "";
            this.claimantInfo.faultPartsList[index].faultPartUnitPrice = "";
            this.$set(this.claimantInfo.faultPartsList[index], "error", true);
            this.getTotalPrice("fault", index);
          } else {
            this.claimantInfo.faultPartsList[
              index
            ].faultPartNameZh = this.faultList[faultIndex].name;
            this.claimantInfo.faultPartsList[index].faultPartName =
              this.faultList[faultIndex][this.claimantInfo.languageType] ||
              this.faultList[faultIndex].en ||
              this.faultList[faultIndex].zh;
            this.claimantInfo.faultPartsList[index].faultPartUnitPrice =
              this.claimantInfo.currency === 0
                ? (
                    this.faultList[faultIndex].price * this.exchangeRate
                  ).toFixed(2)
                : this.faultList[faultIndex].price;
            this.claimantInfo.faultPartsList[index].error = undefined;
            this.getTotalPrice("fault", index);
          }
        }
        this.showfaultListError =
          this.claimantInfo.faultPartsList.findIndex(item => {
            return item.error === true;
          }) !== -1;
      } else {
        await this.findFault();
        this.$refs.form.validateField("faultPartNumber");
      }
    },
    // 处理供应商代码输入框失去焦点的事件
    handleSupplierCodeBlur(row, index) {
      // 当代码是手动输入时，可以在这里清空自动填充的名称，避免混淆
      if (this.isManualSupplierCode(row.responsibilitySupplierCode, index)) {
        // 手动输入代码后，名称输入框为空
        // row.responsibilitySupplier = '';
      }
    },
    // 判断一个供应商代码是否是手动输入的（即不在预定义的supplierList中）
    isManualSupplierCode(code, index) {
      if (!code) return false;
      const list = this.supplierList[index] || [];
      // 检查code是否存在于当前行的供应商列表中
      return !list.some(item => item.lifnr === code);
    },
    // responsibilitySupplierCodeChange(row, rowIndex, i) {
    //   // ... 你原有的逻辑，根据选中的code从supplierList中查找并设置名称 ...
    //   const selectedSupplier = this.supplierList[rowIndex].find(item => item.lifnr === row.responsibilitySupplierCode);
    //   if (selectedSupplier) {
    //     // 假设供应商名称的字段名是 'name'，请根据你的实际数据结构调整
    //     row.responsibilitySupplier = selectedSupplier.name || selectedSupplier.lifnr;
    //   }
    // },
    // 清楚浮点数
    removeIntegerPart(num) {
      let numStr = num.toString();
      let decimalPart = numStr.split(".")[1];
      let dotNume = Number(decimalPart ? "0." + decimalPart : "0").toFixed(2);
      return Number(numStr.split(".")[0]) + Number(dotNume);
    },
    // 选择故障件
    handleSelect(item, index) {
      if (index === 0 || index) {
        this.claimantInfo.faultPartsList[index].faultPartNameZh = item.name;
        this.claimantInfo.faultPartsList[index].faultPartName =
          item[this.claimantInfo.languageType] || item.en || item.zh;
        this.claimantInfo.faultPartsList[index].faultPartUnitPrice =
          this.claimantInfo.currency === 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price;
        this.claimantInfo.faultPartsList[index].error = undefined;
        this.showfaultListError =
          this.claimantInfo.faultPartsList.findIndex(item => {
            return item.error === true;
          }) !== -1;
        this.getTotalPrice("fault", index);
      } else {
        this.$set(this.claimantInfo, "faultPartNameZh", item.name);
        this.$set(
          this.claimantInfo,
          "faultPartName",
          item[this.claimantInfo.languageType] || item.en || item.zh
        );
        this.$set(
          this.claimantInfo,
          "faultPartUnitPrice",
          this.claimantInfo.currency === 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price
        );
        this.getTotalPrice("fault");
        this.$emit("update:faultError", false);
      }
    },
    // 获取金额
    getTotalPrice(type, index) {
      if (type === "fault") {
        if (index === 0 || index) {
          // 工时费用（维修方案区分不同算法）
          if (
            (this.claimantInfo.faultPartsList[index].workingHours == 0 ||
              this.claimantInfo.faultPartsList[index].workingHours) &&
            (this.claimantInfo.faultPartsList[index].changeQuantity == 0 ||
              this.claimantInfo.faultPartsList[index].changeQuantity) &&
            (this.claimantInfo.hourlyRate == 0 || this.claimantInfo.hourlyRate)
          ) {
            if (this.claimantInfo.faultPartsList[index].repairPlan == 0) {
              // 工时*工时单价*更换数量
              this.claimantInfo.faultPartsList[index].laborCost =
                this.claimantInfo.faultPartsList[index].workingHours *
                this.claimantInfo.hourlyRate *
                this.claimantInfo.faultPartsList[index].changeQuantity;
            } else {
              // 工时*工时单价
              this.claimantInfo.faultPartsList[index].laborCost =
                this.claimantInfo.faultPartsList[index].workingHours *
                this.claimantInfo.hourlyRate;
            }
          } else {
            this.claimantInfo.faultPartsList[index].laborCost = undefined;
          }

          // 材料费用 单价*数量*（1+管理费率）
          if (
            (this.claimantInfo.faultPartsList[index].faultPartUnitPrice == 0 ||
              this.claimantInfo.faultPartsList[index].faultPartUnitPrice) &&
            (this.claimantInfo.faultPartsList[index].changeQuantity == 0 ||
              this.claimantInfo.faultPartsList[index].changeQuantity) &&
            (this.claimantInfo.faultPartsList[index].managementFeeRate == 0 ||
              this.claimantInfo.faultPartsList[index].managementFeeRate)
          ) {
            this.claimantInfo.faultPartsList[index].materialCost =
              this.claimantInfo.faultPartsList[index].faultPartUnitPrice *
              this.claimantInfo.faultPartsList[index].changeQuantity *
              (1 + this.claimantInfo.faultPartsList[index].managementFeeRate);
          } else {
            this.claimantInfo.faultPartsList[index].materialCost = undefined;
          }
          // 单个故障件总金额
          if (
            (this.claimantInfo.faultPartsList[index].laborCost == 0 ||
              this.claimantInfo.faultPartsList[index].laborCost) &&
            (this.claimantInfo.faultPartsList[index].materialCost == 0 ||
              this.claimantInfo.faultPartsList[index].materialCost) &&
            (this.claimantInfo.faultPartsList[index].shippingFee == 0 ||
              this.claimantInfo.faultPartsList[index].shippingFee) &&
            (this.claimantInfo.faultPartsList[index].tariff == 0 ||
              this.claimantInfo.faultPartsList[index].tariff)
            // &&
            // (this.claimantInfo.faultPartsList[index].otherExpenses == 0 ||
            //   this.claimantInfo.faultPartsList[index].otherExpenses)
          ) {
            this.claimantInfo.faultPartsList[index].faultPartTotalPrice =
              Number(this.claimantInfo.faultPartsList[index].laborCost || 0) +
              Number(
                this.claimantInfo.faultPartsList[index].materialCost || 0
              ) +
              Number(this.claimantInfo.faultPartsList[index].shippingFee || 0) +
              Number(this.claimantInfo.faultPartsList[index].tariff || 0) +
              Number(
                this.claimantInfo.faultPartsList[index].otherExpenses || 0
              );
            this.claimantInfo.faultPartsList[
              index
            ].faultPartTotalPrice = this.removeIntegerPart(
              this.claimantInfo.faultPartsList[index].faultPartTotalPrice
            );
          } else {
            this.claimantInfo.faultPartsList[
              index
            ].faultPartTotalPrice = undefined;
          }
        }
        if (this.claimantInfo.faultPartsList.length > 0) {
          let materialTotal = 0;
          let workingHoursTotal = 0;
          let laborCostTotal = 0;
          let freightTotal = 0;
          let tariffTotal = 0;
          let otherTotal = 0;
          this.claimantInfo.faultPartsList?.map(item => {
            if (item.sourceOfComponents) {
              if (item.sourceOfComponents == 1) {
                materialTotal += Number(
                  item.materialCost ? item.materialCost : 0
                ); // 计算材料总费用
              }
            } else {
              materialTotal += Number(
                item.materialCost ? item.materialCost : 0
              ); // 计算材料总费用
            }
            workingHoursTotal += Number(
              item.workingHours ? item.workingHours : 0
            ); // 计算总工时
            laborCostTotal += Number(item.laborCost ? item.laborCost : 0); // 计算工时总费用
            freightTotal += Number(item.shippingFee ? item.shippingFee : 0); // 计算总运费
            tariffTotal += Number(item.tariff ? item.tariff : 0); // 计算总关税
            otherTotal += Number(item.otherExpenses ? item.otherExpenses : 0); // 计算其他总费用
          });
          this.$set(this.claimantInfo, "materialTotalCost", materialTotal);
          this.$set(this.claimantInfo, "manHour", workingHoursTotal);
          this.$set(this.claimantInfo, "totalCostOfWork", laborCostTotal);
          this.$set(this.claimantInfo, "freight", freightTotal);
          this.$set(this.claimantInfo, "tariff", tariffTotal);
          this.$set(this.claimantInfo, "otherTotalCost", otherTotal);
        } else {
          this.$set(this.claimantInfo, "materialTotalCost", undefined);
          this.$set(this.claimantInfo, "manHour", undefined);
          this.$set(this.claimantInfo, "totalCostOfWork", undefined);
          this.$set(this.claimantInfo, "freight", undefined);
          this.$set(this.claimantInfo, "tariff", undefined);
          this.$set(this.claimantInfo, "otherTotalCost", undefined);
        }
        if (
          (this.claimantInfo.totalCostOfWork ||
            this.claimantInfo.totalCostOfWork === 0) &&
          (this.claimantInfo.materialTotalCost ||
            this.claimantInfo.materialTotalCost === 0) &&
          (this.claimantInfo.otherTotalCost ||
            this.claimantInfo.otherTotalCost === 0) &&
          (this.claimantInfo.freight || this.claimantInfo.freight === 0) &&
          (this.claimantInfo.tariff || this.claimantInfo.tariff === 0)
        ) {
          this.$set(
            this.claimantInfo,
            "claimTotalCost",
            Number(this.claimantInfo.totalCostOfWork) +
              Number(this.claimantInfo.materialTotalCost) +
              Number(this.claimantInfo.otherTotalCost) +
              Number(this.claimantInfo.freight) +
              Number(this.claimantInfo.tariff)
          );
        } else {
          this.$set(this.claimantInfo, "claimTotalCost", undefined);
        }
      }
    },
    // 获取供应商列表
    getSupplierList(row, index) {
      if (!row.faultPartNumber) return;
      gysPriceFillOutdataList({ faultPartNumber: row.faultPartNumber }).then(
        res => {
          if (res.status == 0) {
            this.$set(this.supplierList, index, res.data || []);
          }
        }
      );
    },
    // 打开二赔编辑弹窗
    handleEditData(title, data) {
      this.$refs.secondCompensationDialogRef.init(title, {
        ...data,
        mainFaultPartNumber: this.claimantInfo.faultPartNumber
      });
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
      this.$emit(
        "update:showExamineBtn",
        this.pageIndex === "detail" ? true : false
      );
    },
    // 获取翻译值
    getTranslateVal(field, value) {
      this.$set(this.claimantInfo, field, value);
    },
    // 历史责任
    handleHistoryResponsibility() {
      this.$refs.historyResponsibilityDialog.init(
        this.claimantInfo.claimStatementId
      );
    },
    // 添加责任主主体
    handleAddResponsibility(i) {
      this.zerenList[i].responsibilityPartList.push({
        responsibilityDepartment: "", // 责任部门
        responsibilityType: "", // 责任类型
        faultPartNumber: "", // 责任故障件件号
        responsibilitySupplierCode: "", // 供应商代码
        responsibilitySupplier: "", // 供应商名称
        responsibilityRatio: undefined, // 责任占比
        currency: 0, // 货币单位
        firstDamages: "", // 初赔金额
        secondDamages: "", // 二赔金额
        responsibilityRemark: "" // 责任说明
      });
    },
    // 删除责任主主体
    handleDeleteResponsibility(index, i) {
      this.zerenList[i].responsibilityPartList.splice(index, 1);
    },
    // 责任类型改变
    responsibilityTypeChange(row, index, i) {
      this.zerenList[i].responsibilityPartList[index].faultPartNumber = ""; // 情况故障件
      if (row.responsibilityType == "1") {
        this.zerenList[i].responsibilityPartList[
          index
        ].responsibilityDepartment = "";
      } else if (row.responsibilityType == "2") {
        this.zerenList[i].responsibilityPartList[
          index
        ].responsibilityDepartment = "供应商";
      } else {
        this.zerenList[i].responsibilityPartList[
          index
        ].responsibilityDepartment = "海外事业部";
      }
    },
    // 责任部门改变
    responsibilityDepartmentChange(row, index, i) {
      this.zerenList[i].responsibilityPartList[index].responsibilitySupplier =
        "";
    },
    // 责任故障件件号改变
    responsibilityPartNumberChange(row, index, i) {
      [...this.claimantInfo.faultPartsList].map(item => {
        if (item.faultPartNumber == row.faultPartNumber) {
          this.zerenList[i].responsibilityPartList[index].faultPartName =
            item.faultPartNameZh;
        }
      });
      this.getSupplierList(row, index);
    },
    // 责任供应商代码改变
    responsibilitySupplierCodeChange(row, index, i) {
      const supplier = this.supplierList[index].find(
        item => item.lifnr === row.responsibilitySupplierCode
      );
      this.zerenList[i].responsibilityPartList[index].responsibilitySupplier =
        supplier?.name1;
      this.zerenList[i].responsibilityPartList[index].sapPrice =
        supplier?.kbetr;
    },
    // 下载
    downLoad(url, index, i) {
      this.$set(
        this.claimantInfo.faultPartsList[i].fileList[index],
        "downStatus",
        true
      );
      window.open(url);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0, 5);
      return "image,video".indexOf(fileExtension) !== -1;
    },
    handleDeleteFaultZeren(i) {
      if (this.zerenList && this.zerenList.length >= 2) {
        this.zerenList.splice(i, 1);
      }
    },
    changefaultPartsData(i) {
      this.zerenList.map(v => {
        if (
          v.faultPartNumber ==
          this.claimantInfo.faultPartsList[i].faultPartNumber
        ) {
          this.zerenList[i].faultPartId = v.faultPartId;
          this.zerenList[i].faultPartName = v.faultPartName;
          this.zerenList[i].faultPartNameZh = v.faultPartNameZh;
        }
      });
    },
    // 添加故障件&&责任列表
    handleAddFaultZeren() {
      if (!this.claimantInfo.faultPartsList) {
        this.$set(this.claimantInfo, "faultPartsList", []);
      }
      this.zerenList.push({
        faultPartId: "",
        claimStatementId: "",
        faultPartNumber: "",
        faultPartName: "",
        faultPartNameZh: "",
        responsibilityPartList: [
          {
            responsibilityDepartment: "", // 责任部门
            responsibilityType: "", // 责任类型
            faultPartNumber: "", // 责任故障件件号
            responsibilitySupplierCode: "", // 供应商代码
            responsibilitySupplier: "", // 供应商名称
            responsibilityRatio: undefined, // 责任占比
            currency: 0, // 货币单位
            firstDamages: "", // 初赔金额
            secondDamages: "", // 二赔金额
            responsibilityRemark: "" // 责任说明
          }
        ]
      });
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    },
    // 编辑后获取责任判定列表
    getResponsibilityList() {
      kdgetResponsibilityListApi({
        claimStatementId: this.claimantInfo.claimStatementId
      }).then(res => {
        if (res.status === "0") {
          let newResponsibilityPartList = res.data || [];
          // 将二赔金额为空时处理，避免为空时显示0
          // newResponsibilityPartList.map((item, index) => {
          //   newResponsibilityPartList[index].secondDamages =
          //     item.secondDamages ?? undefined;
          // });
          this.claimantInfo.faultPartsList = newResponsibilityPartList;
          this.zerenList = newResponsibilityPartList;
          // location.reload();
        }
      });
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.detail-container {
  padding-bottom: 20px;
  ::v-deep .el-table__body .el-input {
    width: unset;
  }
  ::v-deep .el-textarea__inner {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      color: #4084ff;
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .form-container {
    margin-top: 34px;
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
  }
  .err-nowarp {
    ::v-deep .el-form-item__error {
      white-space: nowrap;
    }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }

    .table-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .text-btn {
        cursor: pointer;
        color: #4084ff;
        padding: 0;
        font-size: 14px;
      }
    }
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .daolei {
    height: 50px;
    display: flex;
    align-content: center;
    justify-content: center;
    line-height: 50px;
  }
  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
  .fanyi-box {
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #1890ff;
    }
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  .file-list {
    margin: 0 10px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
</style>
